module.exports = __webpack_public_path__ + "img/covid.f727eb5d.png";